import config from "@/config"
import { msTimestampFormat } from "@/utils"

export const getColumns = (context: any) => {
    return [
        {
            title: "标题",
            dataIndex: "title",
            width: 150,
            filter: {
                type: "input"
            },
            scopedSlots: { customRender: "custom_title" }
        },
        {
            title: "产品名称",
            dataIndex: "product_name",
            width: 150,
            filter: {
                type: "input"
            }
        },
        {
            title: "上架平台",
            dataIndex: "product_sub_type",
            width: 150,
            filter: {
                type: "select",
                mode: "multiple",
                options: context.product_sub_type
            },
            renderType: "select",
            renderProps: {
                options: context.product_sub_type
            }
        },
        {
            title: "产品线",
            dataIndex: "software_name",
            width: 150,
            filter: {
                type: "input"
            }
        },
        {
            title: "文本类型",
            dataIndex: "text_type",
            width: 150,
            filter: {
                type: "select",
                options: context.privacy_policy_text_type,
                mode: "multiple"
            },
            customRender: (text: number) => {
                return context.textTypeMap[text] || "-"
            }
        },
        {
            title: "区域",
            dataIndex: "area",
            width: 100,
            filter: {
                type: "select",
                options: context.area,
                mode: "multiple"
            },
            customRender: (text: number) => {
                return context.areaMap[text] || "-"
            }
        },
        {
            title: "状态",
            dataIndex: "status",
            width: 150,
            filter: {
                type: "select",
                options: context.privacy_policy_status,
                mode: "multiple"
            },
            customRender: (text: number) => {
                return context.PolicyStatusMap[text] || "-"
            }
        },
        {
            title: "经办人",
            dataIndex: "director",
            width: 120,
            filter: {
                type: "user",
                mode: 1,
                multiple: true
            },
            renderProps: {
                showPopover: true,
                platform_id: config.api.PID
            },
            renderType: "user"
        },
        {
            title: "申请日期",
            dataIndex: "apply_time",
            width: 150,
            filter: {
                type: "date"
            },
            sort: {},
            customRender: (text: number) => {
                return text ? msTimestampFormat(text, "YYYY-MM-DD") : "-"
            }
        },
        {
            title: "编制状态",
            dataIndex: "preparation_status",
            width: 150,
            filter: {
                type: "select",
                mode: "multiple",
                options: context.preparation_status
            },
            customRender: (text: number) => {
                return context.preparationStatusMap[text] || "-"
            }
        },
        {
            title: "审批编号",
            dataIndex: "approval_id",
            width: 180,
            filter: {
                type: "input"
            },
            renderType: "link",
            renderProps: {
                onClick: (e: any) => {
                    context.onViewApply([e])
                }
            }
        },
        {
            title: "部署时间",
            dataIndex: "deploy_time",
            width: 150,
            filter: {
                type: "date"
            },
            sort: {},
            customRender: (text: number) => {
                return text ? msTimestampFormat(text) : "-"
            }
        },
        {
            title: "下一版本生效日期",
            dataIndex: "next_version_effective_time",
            width: 150,
            filter: {
                type: "date"
            },
            sort: {},
            customRender: (text: number) => {
                return text ? msTimestampFormat(text, "YYYY-MM-DD") : "-"
            }
        },
        {
            title: "版本号",
            dataIndex: "version_number",
            width: 150,
            filter: {
                type: "input"
            }
        }
    ]
}
